import {
    OBJECT_TYPE_ROUND_TABLE,
    OBJECT_TYPE_RECTANGLE_TABLE,
    OBJECT_TYPE_ROW,
    OBJECT_TYPE_SECTOR,
    OBJECT_TYPE_SEAT,
    OBJECT_TYPE_GENERAL_ADMISSION,
} from '%paysera_seat_selection/js/seatSelection/config/constants';

function getSeatingMapObjectLabel(object) {
    const { objectType } = object;
    if (objectType === OBJECT_TYPE_ROW) {
        const { labelLeft, labelRight } = object;

        return labelLeft?.text !== null ? labelLeft : labelRight;
    }
    if ([
        OBJECT_TYPE_ROUND_TABLE,
        OBJECT_TYPE_SECTOR,
        OBJECT_TYPE_SEAT,
        OBJECT_TYPE_RECTANGLE_TABLE,
        OBJECT_TYPE_GENERAL_ADMISSION,
    ].includes(objectType)) {
        const { label } = object;

        return label;
    }

    return null;
}

export default getSeatingMapObjectLabel;
